<div class="protect-custom-package" (click)="showHideExtendedPart()">
  <span class="protect-custom-package-img-span">
    <img class="protect-custom-package-img" src="./assets/set_new.png" alt="">
  </span>
  <span class="protect-custom-package-title">СЪЗДАЙТЕ ПАКЕТ
    <div>ПО ВАШ ИЗБОР</div>
  </span>
  <span class="protect-custom-package-icon-span">
    <nx-icon name="plus-circle" class="white" size="s" aria-hidden="true"></nx-icon>
  </span>
</div>

@if (isExtendedPartActive) {
  <div class="protect-custom-package-extended-part">
    <!-- Group 1 -->
    <div class="group-1">
      <div class="group-1-text">ЗАЩИТА В РЕЗУЛТАТ НА ЗЛОПОЛУКА</div>
      <div class="group-1-button-div">
        <button type="button" class="checkboxes-group-1-button" (click)="showHideCheckboxesGroup(1)">
          <span class="checkboxes-group-1-button-text"> ИЗБЕРИ </span>
          @if (!isCheckboxesGroup1Active) {
            <span>
              <nx-icon name="chevron-right" size="s" class="white checkboxes-group-3-button-arrow" aria-hidden="true"></nx-icon>
            </span>
          }
          @if (isCheckboxesGroup1Active) {
            <span>
              <nx-icon name="chevron-down" size="s" class="white checkboxes-group-3-button-arrow" aria-hidden="true"></nx-icon>
            </span>
          }
        </button>
      </div>
      @if (isCheckboxesGroup1Active) {
        <div class="checkboxesGroup1">
          <div class="checkbox1">
            <span class="checkboxes-group-1-checkbox">
              <div [ngClass]="{'is-checked':isDeathChecked}" class="custom-checkbox-div">
                @if (isDeathChecked) {
                  <nx-icon name="check" size="s" aria-hidden="true"></nx-icon>
                }
              </div>
              <input class="custom-checkbox" [(ngModel)]="isDeathChecked" type="checkbox" />
            </span>
            <span (click)="isDeathClicked = !isDeathClicked" class="checkboxes-group-1-text">Смърт в резултат на злополука</span>
            @if (isDeathClicked) {
              <div class="container-style"> На ползващите лица се изплаща договорената застрахователна сума в
                <b>двоен размер</b>.
              </div>
            }
          </div>
          <div class="checkbox2">
            <span class="checkboxes-group-1-checkbox" (click)="checkboxesChangesHandle('temporraryLossOfEmploymentByAccident')">
              <div [ngClass]="{'is-checked':isTemporraryLossOfEmploymentByAccidentChecked}" class="custom-checkbox-div">
                @if (isTemporraryLossOfEmploymentByAccidentChecked) {
                  <nx-icon name="check" size="s" aria-hidden="true"></nx-icon>
                }
              </div>
              <input class="custom-checkbox" [(ngModel)]="isTemporraryLossOfEmploymentByAccidentChecked" type="checkbox" />
            </span>
            <span (click)="isTemporraryLossOfEmploymentByAccidentClicked = !isTemporraryLossOfEmploymentByAccidentClicked" class="checkboxes-group-1-text" ng-disabled="isExpenditureForMedicinesByDiseaseChecked">Временна загуба на трудоспособност в резултат на злополука</span>
            @if (isTemporraryLossOfEmploymentByAccidentClicked) {
              <div class="container-style"> Обезщетение за всяка седмица след 2-рата, но за не повече от 21 седмици при злополука за едно събитие и за всички заедно в рамките на една застрахователна година.</div>
            }
          </div>
          <div class="checkbox3">
            <span class="checkboxes-group-1-checkbox" (click)="checkboxesChangesHandle('longTermLossOfEmploymentByAccident')">
              <div [ngClass]="{'is-checked':isLongTermLossOfEmploymentByAccidentChecked}" class="custom-checkbox-div">
                @if (isLongTermLossOfEmploymentByAccidentChecked) {
                  <nx-icon name="check" size="s" aria-hidden="true"></nx-icon>
                }
              </div>
              <input class="custom-checkbox" [(ngModel)]="isLongTermLossOfEmploymentByAccidentChecked" type="checkbox" />
            </span>
            <span (click)="isLongTermLossOfEmploymentByAccidentClicked = !isLongTermLossOfEmploymentByAccidentClicked" class="checkboxes-group-1-text">Трайно намалена работоспособност над 70% в резултат на злополука</span>
            @if (isLongTermLossOfEmploymentByAccidentClicked) {
              <div class="container-style"> Изплаща се процент от застрахователната сума, равен на процента трайно намалена работоспособност определен от Териториалната експертна лекарска комисия (ТЕЛК). </div>
            }
          </div>
          <div class="checkbox4">
            <span class="checkboxes-group-1-checkbox" (click)="checkboxesChangesHandle('stayAtHospitalByAccident')">
              <div [ngClass]="{'is-checked':isStayAtHospitalByAccidentChecked}" class="custom-checkbox-div">
                @if (isStayAtHospitalByAccidentChecked) {
                  <nx-icon name="check" size="s" aria-hidden="true"></nx-icon>
                }
              </div>
              <input class="custom-checkbox" [(ngModel)]="isStayAtHospitalByAccidentChecked" type="checkbox" />
            </span>
            <span (click)="isStayAtHospitalByAccidentClicked = !isStayAtHospitalByAccidentClicked" class="checkboxes-group-1-text">Болничен престой при злополука</span>
            @if (isStayAtHospitalByAccidentClicked) {
              <div class="container-style">  За всеки пълен ден (мин. 24 часа) болничен престой на територията на Република България за максимум 30 дни на година за едно или за всички събития в една застрахователна година. </div>
            }
          </div>
          <div class="checkbox5">
            <span class="checkboxes-group-1-checkbox" (click)="checkboxesChangesHandle('expenditureForMedicinesByAccident')">
              <div [ngClass]="{'is-checked':isExpenditureForMedicinesByAccidentChecked}" class="custom-checkbox-div">
                @if (isExpenditureForMedicinesByAccidentChecked) {
                  <nx-icon name="check"  size="s" aria-hidden="true"></nx-icon>
                }
              </div>
              <input class="custom-checkbox" [(ngModel)]="isExpenditureForMedicinesByAccidentChecked" type="checkbox" />
            </span>
            <span (click)="isExpenditureForMedicinesByAccidentClicked = !isExpenditureForMedicinesByAccidentClicked" class="checkboxes-group-1-text">Лекарски прегледи в резултат на злополука</span>
            @if (isExpenditureForMedicinesByAccidentClicked) {
              <div class="container-style">
                Обезщетение за извършен лекарски преглед в България във връзка с лечението на последиците от една злополука, довела до временна загуба на трудоспособност общо за една застрахователна година.
              </div>
            }
          </div>
        </div>
      }
    </div>
    <!-- Group 1 -->
    <!-- Group 2 -->
    @if (!hideIllnessWhenOver65Years) {
      <div class="group-2">
        <div class="group-2-text">ЗАЩИТА В РЕЗУЛТАТ НА ЗАБОЛЯВАНЕ И/ИЛИ ЗЛОПОЛУКА</div>
        <div class="group-2-button-div">
          <button type="button" class="checkboxes-group-2-button" (click)="showHideCheckboxesGroup(2)">
            <span class="checkboxes-group-2-button-text"> ИЗБЕРИ </span>
            @if (!isCheckboxesGroup2Active) {
              <span>
                <nx-icon name="chevron-right" class="checkboxes-group-3-button-arrow" size="s"  aria-hidden="true"></nx-icon>
              </span>
            }
            @if (isCheckboxesGroup2Active) {
              <span>
                <nx-icon name="chevron-down" class="checkboxes-group-3-button-arrow " size="s" aria-hidden="true"></nx-icon>
              </span>
            }
          </button>
        </div>
        @if (isCheckboxesGroup2Active) {
          <div class="checkboxesGroup2">
            <div class="checkbox6">
              <span class="checkboxes-group-2-checkbox" (click)="checkboxesChangesHandle('temporraryLossOfEmploymentByDisease')">
                <div [ngClass]="{'is-checked':isTemporraryLossOfEmploymentByDiseaseChecked}" class="custom-checkbox-div">
                  @if (isTemporraryLossOfEmploymentByDiseaseChecked) {
                    <nx-icon name="check"  size="s" aria-hidden="true"></nx-icon>
                  }
                </div>
                <input class="custom-checkbox" [(ngModel)]="isTemporraryLossOfEmploymentByDiseaseChecked" type="checkbox" />
              </span>
              <span (click)="isTemporraryLossOfEmploymentByDiseaseClicked = !isTemporraryLossOfEmploymentByDiseaseClicked" class="checkboxes-group-2-text">Временно намалена трудоспособност при злополука и/или заболяване</span>
              @if (isTemporraryLossOfEmploymentByDiseaseClicked) {
                <div class="container-style"> Обезщетение за всяка седмица след 2-рата, но за не повече от 17 седмици при злополука / след 3-тата, но за не повече от 17 седмици при заболяване/ за едно събитие и за всички заедно в рамките на една застрахователна година.</div>
              }
            </div>
            <div class="checkbox7">
              <span class="checkboxes-group-2-checkbox" (click)="checkboxesChangesHandle('longTermLossOfEmploymentByDisease')">
                <div [ngClass]="{'is-checked':isLongTermLossOfEmploymentByDiseaseChecked}" class="custom-checkbox-div">
                  @if (isLongTermLossOfEmploymentByDiseaseChecked) {
                    <nx-icon name="check"  size="s" aria-hidden="true"></nx-icon>
                  }
                </div>
                <input class="custom-checkbox" [(ngModel)]="isLongTermLossOfEmploymentByDiseaseChecked" type="checkbox" />
              </span>
              <span (click)="isLongTermLossOfEmploymentByDiseaseClicked = !isLongTermLossOfEmploymentByDiseaseClicked" class="checkboxes-group-2-text">Трайно намалена работоспособност над 70% в резултат на злополука и/или заболяване</span>
              @if (isLongTermLossOfEmploymentByDiseaseClicked) {
                <div class="container-style"> Изплаща се процент от застрахователната сума, равен на процента трайно намалена работоспособност определен от Териториалната експертна лекарска комисия (ТЕЛК). </div>
              }
            </div>
            <div class="checkbox8">
              <span class="checkboxes-group-2-checkbox" (click)="checkboxesChangesHandle('stayAtHospitalByDisease')">
                <div [ngClass]="{'is-checked':isStayAtHospitalByDiseaseChecked}" class="custom-checkbox-div">
                  @if (isStayAtHospitalByDiseaseChecked) {
                    <nx-icon name="check" size="s" aria-hidden="true"></nx-icon>
                  }
                </div>
                <input class="custom-checkbox" [(ngModel)]="isStayAtHospitalByDiseaseChecked" type="checkbox" />
              </span>
              <span (click)="isStayAtHospitalByDiseaseClicked = !isStayAtHospitalByDiseaseClicked" class="checkboxes-group-2-text">Болничен престой при злополука или заболяване</span>
              @if (isStayAtHospitalByDiseaseClicked) {
                <div class="container-style">  За всеки пълен ден (мин. 24 часа) болничен престой /при заболяване след 3-ти ден/ на територията на Република България за максимум 30 дни на година за едно или за всички събития в една застрахователна година. </div>
              }
            </div>
            <div class="checkbox9">
              <span class="checkboxes-group-2-checkbox" (click)="checkboxesChangesHandle('expenditureForMedicinesByDisease')">
                <div [ngClass]="{'is-checked':isExpenditureForMedicinesByDiseaseChecked}" class="custom-checkbox-div">
                  @if (isExpenditureForMedicinesByDiseaseChecked) {
                    <nx-icon name="check" size="s" aria-hidden="true"></nx-icon>
                  }
                </div>
                <input class="custom-checkbox" [(ngModel)]="isExpenditureForMedicinesByDiseaseChecked" type="checkbox" />
              </span>
              <span (click)="isExpenditureForMedicinesByDiseaseClicked = !isExpenditureForMedicinesByDiseaseClicked" class="checkboxes-group-2-text">Лекарски прегледи в резултат на злополука и/или заболяване</span>
              @if (isExpenditureForMedicinesByDiseaseClicked) {
                <div class="container-style">
                  Обезщетение за извършен лекарски преглед в България във връзка с лечението на последиците от една злополука или за лечението на едно заболяване, установено за първи път, довели до временна загуба на трудоспособност общо за една застрахователна година.
                  Това покритие задължително се комбинира с „Временно намалена трудоспособност при злополука и/или заболяване“
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
    <!-- Group 2 -->
    <!-- Group 3 -->
    @if (!hideIllnessWhenOver65Years) {
      <div class="group-3">
        <div class="group-3-text">ДОПЪЛНИТЕЛНА ГРИЖА ЗА ВАШЕТО ЗДРАВЕ</div>
        <div class="group-3-button-div">
          <button type="button" class="checkboxes-group-3-button" (click)="showHideCheckboxesGroup(3)">
            <span class="checkboxes-group-3-button-text"> ИЗБЕРИ </span>
            @if (!isCheckboxesGroup3Active) {
              <span>
                <nx-icon name="chevron-right" size="s" class="white checkboxes-group-3-button-arrow" aria-hidden="true"></nx-icon>
              </span>
            }
            @if (isCheckboxesGroup3Active) {
              <span>
                <nx-icon name="chevron-down" size="s" class="white checkboxes-group-3-button-arrow" aria-hidden="true"></nx-icon>
              </span>
            }
          </button>
        </div>
        @if (isCheckboxesGroup3Active) {
          <div class="checkboxesGroup3">
            <div class="checkboxesGroup3-text" (click)="showHideCrillDescription()">ТЕЖКИ ЗАБОЛЯВАНИЯ</div>
            @if (isCrillDescriptionActive) {
              <div class="crill-info-container">
                <ul>
                  <li>Доброкачествен тумор на мозъка</li>
                  <li>Слепота</li>
                  <li>Кома</li>
                  <li>Аорто-коронарни байпас графтове</li>
                  <li>Сърдечен удар</li>
                  <li>Бъбречна недостатъчност</li>
                  <li>Животозастрашаващ рак</li>
                  <li>Загуба на слух</li>
                  <li>Загуба на говор</li>
                  <li>Трансплантация на органи</li>
                  <li>Парализа/Инсулт</li>
                  <li>Тежки изгаряния</li>
                </ul>
              </div>
            }
            <div class="checkboxesGroup3-text" (click)="showHideSecondMedicalOpinionDescription()">ВТОРО МЕДИЦИНСКО МНЕНИЕ </div>
            @if (isSecondMedicalOpinionDescriptionActive) {
              <div class="crill-info-container">
                При диагностициране на заболяване неизискващо спешно лечение, получавате експертна препоръка за най-подходящото лечение от
                водещи световни специалисти: Услугата включва:
                <ul>
                  <li>Заявяване към MediGuide ползването на второ медицинско мнение</li>
                  <li>Водещи световни медицински клиники</li>
                  <li>Избор на клиниката, от която искате да получите второто медицинско мнение</li>
                  <li>В срок от 10 работни дни получавате доклад за първоначалната диагноза и предложен план за лечение</li>
                </ul>
              </div>
            }
            <div class="checkboxesGroup3-button">
              @if (!isCrillAndSecMedOPChecked) {
                <button type="button" class="add-button" (click)="addCrillAndSecondMedicalOpinion()">
                  <span class="add-button-text"> ДОБАВИ </span>
                </button>
              }
              @if (isCrillAndSecMedOPChecked) {
                <button type="button" class="add-button clear-button" (click)="removeCrillAndSecondMedicalOpinion()">
                  <span class="add-button-text"> ИЗЧИСТИ </span>
                </button>
              }
              @if (isCrillAndSecMedOPChecked) {
                <div>Успешно добавихте: Допълнителна грижа за Вашето здраве към Вашата застраховка</div>
              }
              @if (isCrillAndSecMedOPUnchecked) {
                <div>Успешно изключихте: Допълнителна грижа за Вашето здраве от Вашата застраховка.</div>
              }
            </div>
          </div>
        }
      </div>
    }
    <!-- Group 3 -->
    <div class="text-align-center">
      <button type="button" class="protect-custom-package-extended-part-button" (click)="calculate()">
        <span class="protect-custom-package-extended-part-button-text"> ИЗЧИСЛИ СВОЯТА ВНОСКА </span>
      </button>
      <div class="protect-custom-package-extended-part-button-error-text">
        @if (noCheckedCheckboxes) {
          <small>За да изчислите вноската си, трябва да изберете поне едно покритие.</small>
        }
        @if (isThereEmptyField) {
          <small>Всички полета са задължителни! <br> Моля попълнете празните полета в текста по-горе!</small>
        }
        @if (!isBornDateCharactersCorrect) {
          <small>Годината Ви на раждане трябва да съдържа само цифри и точки!</small>
        }
        @if (!isBornDateMonthAndDayCorrect) {
          <small>Годината Ви на раждане съдържа невалиден месец или ден!</small>
        }
        @if (!isBornDateLengthCorrect) {
          <small>Годината Ви на раждане трябва да съдържа 10 символа!</small>
        }
        @if (!isBornDateCorrect) {
          <small>Вашата възраст трябва да бъде между 14 и 60г. <br> и не повече от 70г. в края на програмата.</small>
        }
        @if (!isYearsOfDurationCorrect) {
          <small>Периодът трябва да бъде между 10 и 30 години.</small>
        }
      </div>
    </div>
  </div>
}